import {
    type FC
} from "react";
import {
    Image,
    TouchableOpacity,
    View
} from "react-native";
import type {
    CampaignCardProps
} from "./type";
import stylesheet from "./stylesheet";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme,
    Text
} from "ncore-ui-kit";
import {
    Clock,
    Pencil
} from "lucide-react-native";
import Linear from "../../../../../assets/images/linear2.png";

const CampaignCard: FC<CampaignCardProps> = ({
    campaignDesc,
    campaignLogo,
    campaignTitle,
    companyTitle,
    isApproved,
    onPress
}) => {
    const {
        spaces,
        colors,
        radiuses
    } = NCoreUIKitTheme.useContext();

    const {
        localize
    } = NCoreUIKitLocalize.useContext();

    return <View
        style={{
            marginBottom: spaces.spacingXl
        }}
    >
        <View
            style={{
                ...stylesheet.editContainer,
                marginBottom: spaces.spacingMd
            }}
        >
            <Text
                variant="titleMediumSize"
            >
                {companyTitle}
            </Text>
            <TouchableOpacity
                style={[
                    stylesheet.editButton,
                    {
                        padding: spaces.spacingSm
                    }
                ]}
                onPress={onPress}
            >
                <Pencil
                    size={16}
                    color={colors.content.icon.high}
                />
            </TouchableOpacity>
        </View>
        <View>
            <Image
                source={{
                    uri: campaignLogo
                }}
                resizeMode="cover"
                style={{
                    ...stylesheet.campaignLogo,
                    borderRadius: radiuses.md
                }}
            />
            <Image
                source={Linear}
                style={[
                    {
                        borderRadius: radiuses.md,
                        ...stylesheet.coverphoto
                    }
                ]}
            />
            {
                isApproved ? null : <View
                    style={[
                        {
                            backgroundColor: colors.content.container.overlay,
                            ...stylesheet.isApprovedContainer,
                            borderRadius: radiuses.md
                        }
                    ]}
                >
                    <View
                        style={[
                            {
                                ...stylesheet.isApprovedContent,
                                right: spaces.spacingMd,
                                top: spaces.spacingMd,
                                borderRadius: radiuses.xs,
                                backgroundColor: colors.content.container.warning,
                                paddingHorizontal: spaces.spacingMd,
                                paddingVertical: spaces.spacingSm
                            }
                        ]}
                    >
                        <Text
                            variant="bodyLargeSize"
                            color="warning"
                            style={{
                                marginRight: spaces.spacingSm
                            }}
                        >
                            {localize("underReview2")}
                        </Text>
                        <Clock
                            color={colors.content.icon.warning}
                            size={14}
                        />
                    </View>
                </View>
            }
            <View
                style={[
                    stylesheet.campaignTag,
                    {
                        paddingHorizontal: spaces.spacingMd,
                        paddingVertical: spaces.spacingSm,
                        backgroundColor: colors.content.container.default,
                        borderRadius: radiuses.lg,
                        left: spaces.spacingMd,
                        top: spaces.spacingMd
                    }
                ]}
            >
                <Text
                    color="high"
                    variant="bodyMediumSize"
                >
                    {companyTitle}
                </Text>
            </View>
            <View
                style={[
                    stylesheet.campaignBottom,
                    {
                        bottom: spaces.spacingMd,
                        left: spaces.spacingMd
                    }
                ]}
            >
                <Text
                    color="onPrimary"
                    variant="bodyMediumSize"
                >
                    {campaignTitle}
                </Text>
                <Text
                    color="onPrimary"
                    variant="bodyMediumSize"
                >
                    {campaignDesc}
                </Text>
            </View>
        </View>
    </View>;
};
export default CampaignCard;
